var pollTimer = null;
var redirectPopup = null;
var features = {
    width: 400,
    height: 599,
    left: 0,
    top: 0,
};
var appHost = null;
var auth0Redirect = '/auth0/signup';
export var calcWindowFeatures = function () {
    var docElem = document === null || document === void 0 ? void 0 : document.documentElement;
    var screen = window.screen;
    var width = window.innerWidth ? window.innerWidth : (docElem === null || docElem === void 0 ? void 0 : docElem.clientWidth) ? docElem.clientWidth : screen.width;
    var height = window.innerHeight
        ? window.innerHeight
        : (docElem === null || docElem === void 0 ? void 0 : docElem.clientHeight) ? docElem.clientHeight
            : screen.height;
    features.left = width / 2 - features.width / 2 + window.screenLeft;
    features.top = height / 2 - features.height / 2 + window.screenTop;
    return "top=" + features.top + ",left=" + features.left + ",height=" + features.height + ",width=" + features.width;
};
export var checkRedirectedHost = function (location) {
    var url = new URL(appHost !== null && appHost !== void 0 ? appHost : 'https://localhost');
    return (location === null || location === void 0 ? void 0 : location.hostname) === url.hostname;
};
export var verifyRedirectAndComplete = function () {
    var location = redirectPopup.location;
    if (checkRedirectedHost(location)) {
        redirectPopup.close();
        var opener_1 = redirectPopup.opener;
        opener_1.location.reload();
        window.clearInterval(pollTimer);
    }
};
export var openAuth0DOMPopup = function (host, login_hint, firstName, lastName) {
    appHost = host;
    if (redirectPopup === null || redirectPopup.closed) {
        var completeUrl = "" + appHost + auth0Redirect;
        var encodedHint = encodeURIComponent(login_hint);
        var encodedFirstName = encodeURIComponent(firstName);
        var encodedLastName = encodeURIComponent(lastName);
        redirectPopup = window.open(completeUrl + "?hint=" + encodedHint + "&firstName=" + encodedFirstName + "&lastName=" + encodedLastName, 'Sign In', calcWindowFeatures());
        if (redirectPopup) {
            pollTimer = window.setInterval(verifyRedirectAndComplete, 450);
        }
    }
    else {
        redirectPopup.focus();
    }
};
//# sourceMappingURL=redirect-popup.js.map